<div class="c-registration-confirmation">
  <div class="c-registration-confirmation__logo">
    <app-logo [size]="'l'"></app-logo>
  </div>
  <div class="c-registration-confirmation__content">
    <div class="c-registration-confirmation__content-check">
      <img src="assets/images/icon-check.svg">
    </div>
    <div class="c-registration-confirmation__content-text">
      <p>{{ 'REGISTRATION_CONFIRMATION.TITLE' | translate }}</p>
    </div>
  </div>
</div>
